import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Button, Table, Container, Row, Col } from 'react-bootstrap';
import "../Login/CollectionEditor.css";

import Logo from "../Logo/Logo";

const OrderDetails = ({ order, combos, moduloBebida }) => {
  const printRef = useRef();

  /* handling print */
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  return (
    <>
      <Container ref={printRef}>
        <Row className="print-centered">
          <Col> <Logo /></Col>
        </Row>
        <h3>📝 Pedido de productos</h3>

        <Row>
          <Col className="print-centered"><h5><strong>Orden Nro: #{order.uid}</strong></h5></Col>
          <Col className="print-centered"><h5><strong>Hora de pedido: {order.horaGeneracion}</strong></h5></Col>
        </Row>

        <Row className="print-centered">
          <Col>
            <h5><strong>Cliente: {order.firstName} {order.lastName}</strong></h5>
            <h5><strong>📞 Teléfono: {order.phone}</strong></h5>
          </Col>
        </Row>

        {/* Tabla con viandas ordenadas por día */}
        <div className="table-responsive">

        <Table striped bordered hover>
          <thead>
            <tr>
              <th>📦Categoria</th>
              <th>🧢Producto</th>
              <th>🔢 Cantidad</th>
              <th>📝 Anotaciones</th>
              {moduloBebida && <th>🥤 Bebida</th>}
            </tr>
          </thead>
          <tbody>
            {combos.map((combo, index) => (
              <tr key={`${combo.id}-${index}`}>
                <td><strong>{combo.dia_semana}</strong></td>
                <td><strong>{combo.name}</strong></td>
                <td><strong>{combo.quantity}</strong></td>
                <td><strong>{combo.anotaciones || "Ninguna"}</strong></td>
                {moduloBebida && (
                  <td><strong>{combo.selectedDrink?.name || "No incluida"}</strong></td>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
        </div>

        <Row className="print-centered">
          <Col>
            {order.deliveryOption === "Retiro en sucursal" && (
              <h4><strong>🏠 Retiro por sucursal: {order.selectedBranch}</strong></h4>
            )}
            {order.deliveryOption === "Envio a domicilio" && (
              <h5><strong>🚚 Domicilio de entrega: {order.deliveryAddress}</strong></h5>
            )}
            <h6>💳 Método de pago: {order.paymentMethod}</h6>
            <h4><strong>💰 Total a cobrar: ${order.precioFinal}</strong></h4>
          </Col>
        </Row>

        <Row>
          <Col><h6>📌 Estado Actual: {order.estado}</h6></Col>
        </Row>
      </Container>
      
      <Button variant="success" onClick={handlePrint}>🖨️ Imprimir Comanda</Button>
    </>
  );
}

export default OrderDetails;
